import { Plus, Trash } from "@phosphor-icons/react";

export const QuestionsEditor = ({ cfg, setCfg }) => {
  const setQ = (i, v) => setCfg((c) => ({ ...c, questions: c.questions.map((q, j) => (j === i ? v : q)) }));
  return (
    <div className="mt-10 pt-8 border-t border-foreground/20" data-testid="admin-speaking-questions">
      <div className="overline">Speaking task 2 · open question</div>
      <p className="mt-2 text-sm text-foreground/75 max-w-3xl">
        Each test picks ONE of these questions at random. The learner answers out loud (up to 2 minutes, 3 tries) and an AI examiner
        marks the transcript out of 10: answers the question (3), range of vocabulary & grammar (3), accuracy (2), organisation (2).
        With both tasks on, the picture is worth 10 and the question 10. With only one, it is worth all 20.
      </p>
      <label className="mt-4 flex items-center gap-2 text-sm">
        <input type="checkbox" checked={cfg.questions_enabled} onChange={(e) => setCfg((c) => ({ ...c, questions_enabled: e.target.checked }))} className="accent-[#ff8000] w-4 h-4" data-testid="admin-speaking-questions-enabled" />
        Include an open question in new tests
      </label>
      <div className="mt-4 space-y-2 max-w-3xl">
        {cfg.questions.map((q, i) => (
          <div key={i} className="flex gap-2" data-testid={`admin-speaking-question-${i}`}>
            <input aria-label={`Question ${i + 1}`} value={q} onChange={(e) => setQ(i, e.target.value)} maxLength={500} placeholder="e.g. Describe a normal day in your life." className="neu-input flex-1 px-3 py-2 text-sm" data-testid={`admin-speaking-question-input-${i}`} />
            <button onClick={() => setCfg((c) => ({ ...c, questions: c.questions.filter((_, j) => j !== i) }))} aria-label="Remove question" data-testid={`admin-speaking-question-remove-${i}`} className="neu-btn px-3"><Trash size={14} /></button>
          </div>
        ))}
        {!cfg.questions.length && <p className="text-xs text-muted-foreground">No questions yet — tests won't include this task.</p>}
      </div>
      <button onClick={() => setCfg((c) => ({ ...c, questions: [...c.questions, ""] }))} data-testid="admin-speaking-add-question" className="neu-btn mt-2 inline-flex items-center gap-1 px-3 py-1.5 text-xs">
        <Plus size={12} weight="bold" /> Add question
      </button>
    </div>
  );
};
